export default defineNuxtPlugin(() => {
    const appIdMapping = {
      'www.halonovel.com': 646844092476492,
      'www.noveliax.com': 811754268399867,
      'nocdn.noveliax.com': 11754268399867,
      'www.noveloria.com': 1419372503086885,
      'www.novelessa.com': 965193597352385,
      'www.noveldrift.com': 807605798755828,
      'www.noveluno.com': 867005292666773,
      'www.runenovel.com': 3793399717622974,
      'www.veranovel.com': 820959687509312,
      'www.neonnovel.com': 869460902170756,
      'www.orbnovel.com': 1095224205840898,
      'www.draconovel.com': 1496999105262781,
      'www.solianovel.com': 1016659880857391,
      'www.horizonnovel.com': 901526852875084,
      'www.velunovel.com': 1158828913055726,
      'www.lumovel.com': 1725328875302131,
      'www.veloranovel.com': 26784874267843770,
      'www.zyronovel.com': 1575423460692036,
      'www.novellurexa.com': 1410056017816018,
      'www.mystovanovel.com': 987093497375604,
      'www.avenovel.com': 1132905105699703,
      'www.elynovel.com': 2217643265706718,
      'www.elunovel.com': 976470978538896,
      'www.virelnovel.com': 1555071806010332,
      'www.talevoranovel.com': 958610513652065,
      'www.novelvirexa.com': 2001905550694460,
      'www.dreamvellenovel.com': 1520366113070100,
      'www.plotaranovel.com': 2059112431695414,
      'localhost:3000': 646844092476492,
      'h5-site1.supergo.io': 646844092476492,
      'h5-site2.supergo.io': 646844092476492,
      'h51.supergo.io': 646844092476492,
      'h52.supergo.io': 646844092476492,
      'pre.noveliax.com': 811754268399867,
    }
    if (process.client) {
        const hostname = window.location.hostname
        window.fbAsyncInit = function () {
            FB.init({
                appId: appIdMapping[hostname],
                cookie: true,
                xfbml: true,
                version: 'v20.0' // 最新 API 版本
            });
            FB.AppEvents.logPageView();
        };

        (function(d, s, id){
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {return;}
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    }
});
